import {ref} from 'vue'

export default ref('')